//constants
import { BILL_ELEMENT_ENTRIES, TIP_CHARGE } from "@dineout-payment-success-ui/constants";

//interfaces
import { IChargeList, IStoreInfo } from "@dineout-payment-success-ui/interfaces";
import { BottomText } from "@dineout-payment-success-ui/interfaces";

//internal deps
import { IDiscount } from "@swiggy-private/checkout-types";

//utils
import { appendString, currencyFormat } from "@dineout-payment-success-ui/utils/index";

export const sanitizeNumericInput = (input: string): string => {
    return input.replace(/[^0-9]/g, "");
};

export const convertToCommaSeparated = (text: string): string => {
    return text.replace(/\B(?=(?:(\d\d)+(\d)(?!\d))+(?!\d))/g, ",");
};

export const getIsOfferExists = (offerValue: string | 0, data: BottomText): boolean => {
    return !offerValue && !data?.bottomText1 && !data?.bottomText2 && !data?.bottomText3;
};

export const getFormattedDiscounts = (discountList?: IDiscount[]) => {
    return discountList?.map(discount => ({
        ...discount,
        value: currencyFormat(Math.floor(Number(discount.value))),
    }));
};

export const getFeeObject = (charges: IChargeList[]) => {
    let feeObject = null;
    charges?.find(item => {
        if (item.type === BILL_ELEMENT_ENTRIES.CONVENIENCE_FEE_TYPE) {
            feeObject = item;
        }
    });
    return feeObject;
};

export const getTipValue = (chargeList?: IChargeList[]): string => {
    const tipObj = chargeList?.find?.(charge => charge.type === TIP_CHARGE);
    return currencyFormat(tipObj?.value || 0);
};

export const getTotalAmountWithoutTip = (tip: string, billAmountWithoutDiscounts: number) => {
    return parseInt(tip) > 0
        ? Math.floor(billAmountWithoutDiscounts) - Math.floor(parseInt(tip))
        : Math.floor(billAmountWithoutDiscounts);
};

export const getRestaurantInfo = (restaurantInfo: IStoreInfo) => {
    const { name, locality, cityName, id } = restaurantInfo;
    const restaurantLocality = appendString(
        restaurantInfo?.landmark || "",
        restaurantInfo?.displayAreaName || locality,
    );
    return {
        restaurantName: name,
        restaurantAddress: `${restaurantLocality ? `${restaurantLocality},` : ""} ${cityName}`,
        restaurantId: id,
        restaurantCity: cityName,
        restaurantLocality,
    };
};
